export const STOREFRONT_API_VERSION = '2026-07';
